export default "__VITE_ASSET__8UEyy4WI__"